import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const MapLegend = ({ title, items, position = 'topright', stats, isMobile }) => { // Add isMobile
  const map = useMap();
  
  useEffect(() => {
    // Create control only if position is not "custom"
    if (position !== 'custom') {
      // Create control
      const legend = L.control({ position });

      legend.onAdd = () => {
        const div = L.DomUtil.create('div', 'info legend');
        div.style.backgroundColor = "white";
        div.style.padding = "8px 12px";
        div.style.borderRadius = "4px";
        div.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
        div.style.fontSize = "14px";
        div.style.maxWidth = "250px";
        div.style.opacity = "0.9";
        
        // Add title
        const titleElement = document.createElement('div');
        titleElement.style.fontWeight = "bold";
        titleElement.style.marginBottom = "8px";
        titleElement.innerHTML = title;
        div.appendChild(titleElement);
        
        // Add legend items
        items.forEach(item => {
          const row = document.createElement('div');
          row.style.display = "flex";
          row.style.alignItems = "center";
          row.style.marginBottom = "5px";
          
          const colorBox = document.createElement('div');
          colorBox.style.width = "20px";
          colorBox.style.height = "20px";
          colorBox.style.backgroundColor = item.color;
          colorBox.style.marginRight = "5px";
          colorBox.style.opacity = item.opacity || 0.7;
          colorBox.style.border = "1px solid rgba(0,0,0,0.2)";
          colorBox.style.borderRadius = "3px";
          colorBox.style.display = "inline-block";
          
          const label = document.createElement('span');
          label.innerHTML = item.label;
          
          row.appendChild(colorBox);
          row.appendChild(label);
          div.appendChild(row);
        });
        
        // Add stats if provided
        if (stats) {
          const statsElement = document.createElement('div');
          statsElement.style.fontSize = "12px";
          statsElement.style.marginTop = "8px";
          statsElement.innerHTML = stats;
          div.appendChild(statsElement);
        }
        
        return div;
      };

      legend.addTo(map);
      
      // Clean up on unmount
      return () => {
        legend.remove();
      };
    }  
  }, [map, title, items, position, stats, isMobile]); // Add isMobile to dependencies

  // Return the div directly if position is custom
  return position === 'custom' ? (
    <div className="info legend" style={{
      backgroundColor: "white",
      padding: isMobile ? "6px 8px" : "8px 12px", // Adjust padding
      borderRadius: "4px", 
      fontSize: isMobile ? "11px" : "14px", // Adjust fontSize
      maxWidth: isMobile ? "140px" : "250px", // Adjust maxWidth
      opacity: "0.9"
    }}>
      <div style={{ fontWeight: "bold", marginBottom: isMobile ? "4px" : "8px" }}>{title}</div>
      
      {items.map((item, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: isMobile ? "3px" : "5px" }}>
          <div style={{ 
            width: isMobile ? "12px" : "20px", // Adjust size
            height: isMobile ? "12px" : "20px", // Adjust size
            backgroundColor: item.color,
            marginRight: "5px",
            opacity: item.opacity || 0.7,
            border: "1px solid rgba(0,0,0,0.2)",
            borderRadius: "3px"
          }}></div>
          <span>{item.label}</span>
        </div>
      ))}
      
      {stats && <div style={{ fontSize: isMobile ? "10px" : "12px", marginTop: isMobile ? "4px" : "8px" }}>{stats}</div>}
    </div>
  ) : null;
};

export default MapLegend;